import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormatPipe } from 'ngx-date-fns';

import { IsoDifferenceInDaysToNowPipe } from './calc-pipes/iso-difference-in-days-to-now.pipe';
import { PolicyStatusDescriptionPipe } from './meta-pipes/policy-status-description.pipe';
import { PolicyStatusIconPipe } from './meta-pipes/policy-status-icon.pipe';
import { RoleDescriptionPipe } from './meta-pipes/role-description.pipe';
import { RenewalStatusHistoryPipe } from './meta-pipes/renewal-status-history.pipe';
import { CobMetaPipe } from './meta-pipes/cob.pipe';
import { MediaUrlPipe } from './other/media-url.pipe';
import { FilterWithPipe } from './other/filter-with.pipe';
import { OrdinalPipe } from './other/ordinal.pipe';
import { Currency2Pipe } from './other/currency2.pipe';
import { CurrencyCodePipe } from './other/currency-code.pipe';
import { RenewalStatusQueue } from './meta-pipes/renewal-status-queue';
import { CastObservablePipe } from './other/cast-observable.pipe';
import { WorkflowMetaPipe } from './meta-pipes/workflow-meta/workflow-meta.pipe';
import { WorkflowStatusHistoryPipe } from './meta-pipes/workflow-meta/workflow-status-history.pipe';
import { ProposalWorkflowMetaPipe } from './meta-pipes/workflow-meta/proposal-workflow-meta.pipe';
import { EnquiryQuoteWorkflowMetaPipe } from './meta-pipes/workflow-meta/enquiry-quote-workflow-meta.pipe';
import { StatusQueueMetaPipe } from './meta-pipes/workflow-meta/status-queue-workflow-meta.pipe';
import { PaymentWorkflowMetaPipe } from './meta-pipes/workflow-meta/payment-workflow-meta.pipe';
import { InfoLevelColorPipe } from './meta-pipes/info-level-color.pipe';
import { PolicyStatusMetaPipe } from './meta-pipes/workflow-meta/policy-status-meta.pipe';
import { PluralizedAddonsListPipe } from './meta-pipes/pluralized-addons-list.pipe';
import { PluralizedListPipe } from './other/pluralized-list.pipe';
import { EndorsementMetaPipe } from './meta-pipes/endorsement-meta.pipe';
import { DocumentIconPipe } from './meta-pipes/document-icon.pipe';
import { InterpolationPipe } from './other/interpolation.pipe';

const publicStandaloneApi = [
  IsoDifferenceInDaysToNowPipe,
  MediaUrlPipe,
  PolicyStatusDescriptionPipe,
  PolicyStatusIconPipe,
  RoleDescriptionPipe,
  RenewalStatusHistoryPipe,
  RenewalStatusQueue,
  FilterWithPipe,
  OrdinalPipe,
  CobMetaPipe,
  CurrencyCodePipe,
  CastObservablePipe,
  WorkflowMetaPipe,
  WorkflowStatusHistoryPipe,
  ProposalWorkflowMetaPipe,
  EnquiryQuoteWorkflowMetaPipe,
  StatusQueueMetaPipe,
  PaymentWorkflowMetaPipe,
  InfoLevelColorPipe,
  PolicyStatusMetaPipe,
  PluralizedAddonsListPipe,
  EndorsementMetaPipe,
  DocumentIconPipe,
  InterpolationPipe,
];

@NgModule({
  imports: [CommonModule, ...publicStandaloneApi],
  exports: [...publicStandaloneApi, Currency2Pipe],
  providers: [
    FormatPipe,
    CurrencyPipe,
    CobMetaPipe,
    CastObservablePipe,
    PluralizedListPipe,
    WorkflowMetaPipe,
    EndorsementMetaPipe,
  ],
  declarations: [Currency2Pipe],
})
export class PipesModule {}
